<template>
  <CFooter :fixed="false">
    <div class="footer">
      <div class="left">
        <a href="index.html" target="_blank"
          ><img
            src="@/images/logo-wh.png"
            alt="Reeracoen Freelance Recruiting Business"
        /></a>
        <span class="copyright"
          >Copyright &copy; {{ new Date().getFullYear() }} Reeracoen. All rights
          reserved.</span
        >
      </div>
      <div class="right">
        <div class="link-group">
          <div>
            <a class="link" href="#" target="_blank">Reeracoen Thailand</a>
          </div>
          <div class="phone">
            <a class="link icon-link" href="tel:+6602-253-9800"
              ><i class="fas fa-phone-volume"></i>(+66)02-253-9800</a
            >
          </div>
        </div>
      </div>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
.c-footer {
  background: #2630e6;
  border: 0;
  color: $white;
  height: auto;
  padding: 2rem 1.5rem;

  .footer {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;

    .left {
      img {
        margin-bottom: 0.5rem;
        opacity: 0.8;
        width: 150px;
      }

      .copyright {
        font-size: 12px;
        opacity: 0.8;
      }
    }

    .right {
      .link-group {
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        & > * {
          margin-bottom: 0;
          margin-right: 1rem;
        }

        & > *:last-child {
          margin-right: 0;
        }

        .link {
          color: $white;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 0;
          opacity: 0.8;

          &:hover,
          &:focus {
            opacity: 1;
          }
        }

        .icon-link {
          align-items: center;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: flex-start;
        }

        .phone {
          i {
            font-size: 18px;
            margin-right: 5px;
            transform: rotate(-45deg);
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 991px) {
  .c-footer {
    padding: 1rem 1rem;

    .footer {
      align-items: flex-start;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: flex-start;

      .left {
        img {
          margin-bottom: 0.5rem;
          width: 100px;
        }
      }

      .right {
        .link-group {
          align-items: center;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          line-height: 2rem;

          & > * {
            margin-right: 1rem;
          }

          & > * :last-child {
            margin-right: 0;
          }

          .link {
            font-size: 12px;
            opacity: 0.8;
          }

          .phone {
            i {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
</style>
